export default class Dealer {
  pricelists;

  constructor(dealerWire, columnById) {
    this.pricelists = dealerWire.dealer_dto_pricelists.map(id => columnById[id]);
  }
}
